<template>
  <div>
    <Header class="yh-header" active="/service/yxzt" showSub :subMenu="subMenu" />
    <div style="height: 130px"></div>
    <el-container class="container">
      <!-- <el-aside width="210px">
        <CommodityMarketingAside mod="yxzt" />
      </el-aside>-->
      <el-main class="yxzt">
        <div class="select">
          <span class="select-year">请选择年份</span>
          <el-date-picker
            class="year"
            v-model="year"
            format="yyyy"
            value-format="yyyy"
            type="year"
            placeholder="选择年"
          ></el-date-picker>
          <el-button type="primary" @click="onYearChange">查询</el-button>
        </div>
        <ProductServiceMonthSelect :active="month" @change="onMonthChange" />

        <MarketingPage @change="onPageChange" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Header from "@/components/Header";

import CommodityMarketingAside from "@/components/CommodityMarketingAside";

import ProductServiceMonthSelect from "@/components/ProductServiceMonthSelect";
import ProductServiceSolarTermSelect from "@/components/ProductServiceSolarTermSelect";

import ProductServiceDiscuss from "@/components/ProductServiceDiscuss";

import MarketingPage from "@/components/MarketingPage";

export default {
  name: "ProductHome",
  components: {
    Header,
    CommodityMarketingAside,
    ProductServiceMonthSelect,
    ProductServiceSolarTermSelect,
    ProductServiceDiscuss,

    MarketingPage
  },
  data() {
    const month = new Date().getMonth() + 1;
    return {
      subMenu: [
        { name: "24节气", path: "/service/fwxs", active: false },
        { name: "营销主题", path: "/service/yxzt", active: true }
      ],
      year: "2019",
      month: month
    };
  },
  created() {
    this.$store.dispatch("commodityMarketingPage", {
      packageName: "marketing",
      className: "commodityMarketing",
      methodName: "retrieve",
      params: {
        type: "营销主题",
        month: this.month,
        numPerPage: 5
      }
    });

    this.ajax.doPost({
      packageName: "user",
      className: "userAnalysis",
      methodName: "create",
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: "商品营销-营销主题",
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    });
  },
  methods: {
    onYearChange() {
      this.$store.dispatch("commodityMarketingPage", {
        packageName: "marketing",
        className: "commodityMarketing",
        methodName: "retrieve",
        params: {
          type: "营销主题",
          year: this.year,
          numPerPage: 5
        }
      });
    },
    onMonthChange(e) {
      this.month = e;

      this.$store.dispatch("commodityMarketingPage", {
        packageName: "marketing",
        className: "commodityMarketing",
        methodName: "retrieve",
        params: {
          type: "营销主题",
          month: e,
          numPerPage: 5
        }
      });
    },
    onPageChange(e) {
      this.$store.dispatch("commodityMarketingPage", {
        packageName: "marketing",
        className: "commodityMarketing",
        methodName: "retrieve",
        params: {
          type: "营销主题",
          pageNum: e,
          month: this.month,
          numPerPage: 5
        }
      });
    }
  }
};
</script>

<style lang="less">
.yxzt {
  .select {
    .select-year {
      color: #333;
    }

    .year {
      margin: 0 10px;
    }

    .el-input__inner {
      // height: 30px;
    }

    .el-button {
    }
  }
}
</style>


<style lang="less" scoped>
.el-header {
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.container {
  width: 1140px;
  margin: 20px auto;
  min-height: 100vh;
}
</style>
